export default "__VITE_ASSET__DCMEk2bB__"